<template>
  <div class="formio-container">
    <div v-if="model.FormCode">
      <formio-form-component v-if="formDefinition && !loadingForm" ref="form" :formCode="code" :formDefinition="formDefinition" />
      <div v-else class="d-flex justify-center align-self-center flex-column align-center">
        <div class="d-flex text--secondary mb-4">{{ $t("vuetifyWidgets.dr-formio.formLoading") }}</div>
        <v-progress-circular class="d-flex mb-3" indeterminate size="64" color="primary"></v-progress-circular>
      </div>
    </div>
    <div clas="dr-formio-empty-form" v-else>
      <p class="text--secondary text-center subtitle-1 ma-0">{{ $t("vuetifyWidgets.dr-formio.specifyFormCode") }}</p>
    </div>
  </div>
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'DrFormioInEditorWrapper',
  mixins: [baseMixin, inputMixin],
  data: () => ({
    formDefinition: null,
    loadingForm: false
  }),
  computed: {
    code() {
      return this.model.FormCode
    },
    needReRender() {
      return  this.$store.state['processes'].needReRender
    }
  },
  watch: {
    code: async function () {
      this.loadingForm = true
      await this.getForm()
    },
    needReRender: async function () {
      if (this.$store.state['processes'].needReRender) {
        this.$store.state['processes'].needReRender = false
        await this.getForm()
      }
    }
  },
  methods: {
    async getForm() {
      const formioParams = this.createFormioParams(this.model.FormioParams)
      this.formDefinition = await this.$store.dispatch('formio/getForm', { formCode: this.code, properties: formioParams })
      this.loadingForm = false
    },
    createFormioParams(formioParams) {
      if (!formioParams) {
        return {}
      }

      let params = {}
      for (const property in formioParams) {
        const value = this.getExternalSourceField(formioParams[property])
        params[property] = value ?? formioParams[property]
      }
      
      return params
    }
  },
  async created() {
    if (!this.model.FormCode) {
      return
    }
    await this.getForm()
  }
}
</script>